import Form from '../../../components/form/Form'
import LineButton from '../../../components/py_modules/LineButton'
import useFormFields from '../../../hooks/useFormFields'

const LineValidation = () => {
  const { lineValidationFieldsPY } = useFormFields()

  const storeForm: string = 'lineValidationPYForm'

  return (
    <main className="form">
      <div className="form-container">
        <h2 className="form-title">Completá los datos de la línea</h2>
        <Form fields={lineValidationFieldsPY} storeForm={storeForm} inputsPosition="floating" />

        <LineButton storeForm={storeForm} />
      </div>
    </main>
  )
}

export default LineValidation
